import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// 메시지 키 타입 정의
type MessageKey = string;

interface SnackbarState {
  isOpen: boolean;
  type: "default" | "success" | "error";
  messageKey: MessageKey;
  actionLabel?: string;
}

interface CommonState {
  snackbar: SnackbarState;
  isGlobalLoadingEnabled: boolean;
}

const initialState: CommonState = {
  snackbar: {
    isOpen: false,
    type: "default",
    messageKey: "",
    actionLabel: "",
  },
  isGlobalLoadingEnabled: false,
};

const common = createSlice({
  name: "common",
  initialState,
  reducers: {
    showSnackbar: (state, action: PayloadAction<Partial<SnackbarState>>) => {
      state.snackbar = { ...state.snackbar, ...action.payload, isOpen: true };
    },
    closeSnackbar: (state) => {
      state.snackbar.isOpen = false;
    },
    setEnabledGlobalLoading: (state, action: PayloadAction<boolean>) => {
      state.isGlobalLoadingEnabled = action.payload;
    },
    resetCommonData: () => initialState,
  },
});

export const {
  showSnackbar,
  closeSnackbar,
  setEnabledGlobalLoading,
  resetCommonData,
} = common.actions;

export default common.reducer;
